/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PartialScheduleAccount = {
  accountID: string;
  displayName: string;
  email?: string | undefined;
};

/** @internal */
export const PartialScheduleAccount$inboundSchema: z.ZodType<
  PartialScheduleAccount,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  displayName: z.string(),
  email: z.string().optional(),
});
/** @internal */
export type PartialScheduleAccount$Outbound = {
  accountID: string;
  displayName: string;
  email?: string | undefined;
};

/** @internal */
export const PartialScheduleAccount$outboundSchema: z.ZodType<
  PartialScheduleAccount$Outbound,
  z.ZodTypeDef,
  PartialScheduleAccount
> = z.object({
  accountID: z.string(),
  displayName: z.string(),
  email: z.string().optional(),
});

export function partialScheduleAccountToJSON(
  partialScheduleAccount: PartialScheduleAccount,
): string {
  return JSON.stringify(
    PartialScheduleAccount$outboundSchema.parse(partialScheduleAccount),
  );
}
export function partialScheduleAccountFromJSON(
  jsonString: string,
): SafeParseResult<PartialScheduleAccount, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PartialScheduleAccount$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PartialScheduleAccount' from JSON`,
  );
}
